import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';

const { FiCalendar, FiLinkedin, FiArrowUpRight } = FiIcons;

const tools = [
  { name: 'Heyreach', url: 'https://heyreach.io/?via=abm', domain: 'heyreach.io' },
  { name: 'Instantly AI', url: 'https://refer.instantly.ai/abm', domain: 'instantly.ai' },
  { name: 'Smartlead AI', url: 'https://smartlead.ai/?via=abdul-monis', domain: 'smartlead.ai' },
  { name: 'Maildoso', url: 'http://getmaildoso.com/?ref=abdul4k', domain: 'getmaildoso.com' },
  { name: 'Apollo', url: 'https://get.apollo.io/abm', domain: 'apollo.io' },
  { name: 'AppSumo', url: 'https://appsumo.com/s/1zyc611/', domain: 'appsumo.com' },
  { name: 'Moltsets', url: 'https://moltsets.com/?via=abm', domain: 'moltsets.com' },
  { name: 'Reoon Verifier', url: 'https://emailverifier.reoon.com/appsumo-offer/?inv=k9cwcay', domain: 'reoon.com' },
];

function App() {
  const [text, setText] = useState('');
  const fullText = "Hey, I'm Abdul Monis.";

  useEffect(() => {
    let currentIndex = 0;
    const intervalId = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(intervalId);
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100 font-sans selection:bg-blue-500/30">
      <div className="max-w-[640px] mx-auto px-6 py-20 md:py-32 space-y-24">
        <div className="space-y-8 flex flex-col items-center text-center">
          <div className="h-12 flex items-center font-mono">
            <h1 className="text-2xl md:text-4xl font-semibold tracking-tight">
              {text}
              <span className="animate-blink text-blue-500 font-light ml-1">|</span>
            </h1>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://calendly.com/abdulmonis7k/chat-with-abdul-monis"
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-neutral-900 border border-neutral-800 rounded-full text-neutral-400 hover:text-white hover:border-neutral-700 transition-all duration-300"
            >
              <SafeIcon icon={FiCalendar} className="w-5 h-5" />
            </a>
            <a
              href="https://www.linkedin.com/in/abdulmonis-/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-neutral-900 border border-neutral-800 rounded-full text-neutral-400 hover:text-white hover:border-neutral-700 transition-all duration-300"
            >
              <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
            </a>
          </div>
        </div>

        <section className="space-y-8">
          <div className="space-y-2">
            <p className="text-[11px] font-bold text-neutral-500 tracking-[0.2em] uppercase">
              Tools
            </p>
            <h2 className="text-2xl md:text-3xl font-semibold text-neutral-100">
              Get the tech stack I use
            </h2>
            <p className="text-neutral-400 text-sm md:text-base">
              These are the tools I personally use and recommend.
            </p>
          </div>

          <div className="border border-neutral-800 rounded-2xl overflow-hidden bg-neutral-900/20">
            {tools.map((tool, index) => (
              <a
                key={tool.name}
                href={tool.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 px-5 py-4 hover:bg-neutral-900/60 transition-colors group"
                style={{
                  borderBottom:
                    index !== tools.length - 1
                      ? '1px solid rgba(38, 38, 38, 0.5)'
                      : 'none',
                }}
              >
                <img
                  src={`https://logo.clearbit.com/${tool.domain}`}
                  alt={tool.name}
                  className="w-9 h-9 rounded-lg border border-neutral-800 bg-neutral-900"
                  onError={(event) => {
                    event.currentTarget.style.display = 'none';
                  }}
                />
                <span className="text-[15px] font-medium text-neutral-200 group-hover:text-white transition-colors">
                  {tool.name}
                </span>
                <SafeIcon
                  icon={FiArrowUpRight}
                  className="ml-auto w-4 h-4 text-neutral-600 group-hover:text-neutral-400 transition-colors"
                />
              </a>
            ))}
          </div>

          <div className="p-6 bg-neutral-900/40 border border-neutral-800 rounded-2xl flex flex-col md:flex-row md:items-center justify-between gap-4">
            <p className="text-neutral-300 text-sm font-medium">
              Need help setting these up?
            </p>
            <a
              href="https://www.upwork.com/freelancers/~01ba398f8a75c35ce2?mp_source=share"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-5 py-2.5 bg-neutral-100 text-neutral-950 rounded-xl text-sm font-semibold hover:bg-white transition-colors gap-2 group"
            >
              Hire me on Upwork
              <SafeIcon
                icon={FiArrowUpRight}
                className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              />
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default App;